<template>
  <div id="default-layout">
    <AsyncTasksNotification />
    <transition name="fade-in">
      <router-view />
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import AsyncTasksNotification from '@/components/generic/AsyncTasksNotification.vue'

export default Vue.extend({
  components: {
    AsyncTasksNotification
  }
})
</script>

<style scoped>
#default-layout {
  height: 100%;
}
</style>
